// export const proxy = "http://164.92.65.62:8080";
// export const imageProxy = "http://164.92.65.62:8080/uploads";
// export const proxy = "http://localhost:8084";
// export const imageProxy = "http://localhost:8080/uploads";
 
export const proxy = "http://138.68.98.76:8084";
 